import { render, staticRenderFns } from "./setting-faq.vue?vue&type=template&id=0c65fe30&scoped=true&"
import script from "./setting-faq.vue?vue&type=script&lang=js&"
export * from "./setting-faq.vue?vue&type=script&lang=js&"
import style0 from "./setting-faq.vue?vue&type=style&index=0&id=0c65fe30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c65fe30",
  null
  
)

export default component.exports